var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 6.933L.2 1.6A1 1 0 011 0h8a1 1 0 01.8 1.6l-4 5.333a1 1 0 01-1.6 0z",
    fill: "#6373A4",
    fillRule: "evenodd"
  })));
}

export default SvgCaret;